import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';

@Injectable({
  providedIn: 'root',
})
export class TokenRenewService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  //Always returns http status 200 for security reasons
  public renewSignup(username: string): Observable<void> {
    const url = this.urlHelper.prepareApiPath(
      'signup',
      `confirmation?username=${encodeURI(username)}`,
    );
    return this.http.put<void>(url, undefined);
  }
}
